import React from "react";


export default function BoostCredit() {

  const campaigns = [
    { name: "dd", location: "Lonavala, Pune", spent: 0, total: 1000, daily: 33, remaining: 1000 },
    { name: "test", location: "Andheri West, Mumbai", spent: 0, total: 2059, daily: 69, remaining: 2059 },
    { name: "Premium Villa Boost - March", location: "Whitefield, Bangalore", spent: 3985.8, total: 5000, daily: 167, remaining: 1014 },
    { name: "HSR Layout Penthouse Promo", location: "HSR Layout, Bangalore", spent: 7327.6, total: 10000, daily: 333, remaining: 2672 }
  ];

  const transactions = [
    { name: "Boost Credits Added", amount: "+15,000 Credits", type: "credit" },
    { name: "HSR Layout Penthouse Promo", amount: "-₹10,000", type: "debit" },
    { name: "Boost Credits Added", amount: "+8,000 Credits", type: "credit" },
    { name: "Downtown Apartment Campaign", amount: "-₹2,500", type: "debit" }
  ];

  return (
    <div className="boost-credit">
         <div className="breadcrumb">
        <span className="light">LandPanda Ads</span>
        <span className="arrow">›</span>
        <span className="bold">Boost Credit</span>
      </div>
    <div className="boost-dashboard">
      <div className="container">

        {/* HEADER */}
        <div className="header">
          <p className="label"><i class="ri-coins-fill text-xs text-white"></i> LandPanda Boost Credits</p>
          <h1>2,450</h1>
          <p className="sub">Available Boost Credits</p>

          <div className="badge">
           <i class="ri-information-line text-emerald-100 text-xs flex-shrink-0"></i>  1 Boost Credit = ₹1 INR • Non-refundable once purchased
          </div>

          <div className="stats">
            <div>
              <p>Total Recharged</p>
              <h3>31,000 Credits</h3>
            </div>
            <div>
              <p>Total Spent</p>
              <h3>20,500 Credits</h3>
            </div>
            <div>
              <p>Est. Daily Burn</p>
              <h3>~₹964</h3>
            </div>
          </div>

          <div className="actions">
            <button className="btn primary"><i class="ri-coins-line text-base"></i> Add Credits</button>
            <button className="btn secondary"><i class="ri-download-2-line text-base"></i> Statement</button>
          </div>
        </div>

        {/* HOW IT WORKS */}
        <div className="card">
          <h3 className="title">
            <i class="ri-information-line text-emerald-500 text-sm green-ico"></i> HOW BOOST CREDITS WORK
          </h3>

          <div className="how-grid">
            <div className="how-item">
              <div className="icon green">+</div>
              <div>
                <h4>Add Credits</h4>
                <p>Purchase Boost Credits anytime via UPI, Card or Net Banking</p>
              </div>
            </div>

            <div className="how-item">
              <div className="icon blue">🚀</div>
              <div>
                <h4>Campaign Launch</h4>
                <p>Boost Credits are used when you launch a campaign</p>
              </div>
            </div>

            <div className="how-item">
              <div className="icon purple">📊</div>
              <div>
                <h4>Track Spend</h4>
                <p>See real-time Boost Credit usage per campaign</p>
              </div>
            </div>
          </div>
        </div>

        {/* CAMPAIGNS */}
        <div className="card">
          <h3 className="title">📢 Active Campaign Spend</h3>

          {campaigns.map((c, i) => {
            const percent = (c.spent / c.total) * 100;

            return (
              <div key={i} className="campaign">
                <div className="campaign-top">

                  <div className="left">
                    <div className="dot" />
                    <div>
                      <h4>{c.name}</h4>
                      <p>{c.location}</p>
                    </div>
                  </div>

                  <div className="right">
                    ₹{c.spent} <span>of ₹{c.total}</span>
                  </div>
                </div>

                <div className="progress">
                  <div style={{ width: percent + "%" }} />
                </div>

                <div className="campaign-bottom">
                  <span>~₹{c.daily}/day</span>
                  <span>₹{c.remaining} remaining</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* TRANSACTIONS */}
        <div className="card">
          <div className="transaction-header">
            <h3>💳 Transaction History</h3>

            <div className="filters">
              <button className="active">All</button>
              <button>Credited</button>
              <button>Debited</button>
            </div>
          </div>

          {transactions.map((t, i) => (
            <div key={i} className="transaction">
              <div className="left">

                <div className={`tx-icon ${t.type}`}>
                  {t.type === "credit" ? "↓" : "↑"}
                </div>

                <div>
                  <h4>{t.name}</h4>
                  <p>Success</p>
                </div>
              </div>

              <div className={t.type === "credit" ? "credit" : "debit"}>
                {t.amount}
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
    </div>
  );
}